module.exports = __webpack_public_path__ + "02_glasses_brown.6285c6bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/02_glasses_brown.png
// module id = Yuu6
// module chunks = 0